import { render, staticRenderFns } from "./AttributeCreateEditModal.vue?vue&type=template&id=0684edf4&"
import script from "./AttributeCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./AttributeCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports